var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 107 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0556641,
    y: 0.592773,
    width: 106,
    height: 71,
    fill: "#0D3288"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.2142 8.59277L52.3043 11.3924H49.3604L51.7444 13.1247L50.8345 15.9243L53.2142 14.192L55.5939 15.9243L54.6884 13.1247L57.0681 11.3924H54.1241L53.2142 8.59277Z",
    fill: "#FCD100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1241 60.0053L53.2142 57.2013L52.3043 60.0053H49.3604L51.7444 61.7332L50.8345 64.5328L53.2142 62.805L55.5939 64.5328L54.6884 61.7332L57.0681 60.0053H54.1241Z",
    fill: "#FCD100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9095 38.5007L31.2892 40.2286L30.3837 37.4289L32.7634 35.701H29.8194L28.9095 32.897L27.9996 35.701H25.0557L27.4397 37.4289L26.5298 40.2286L28.9095 38.5007Z",
    fill: "#FCD100"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0619 11.8516L40.152 14.6512H37.208L39.5921 16.3791L38.6822 19.1787L41.0619 17.4464L43.4415 19.1787L42.5317 16.3791L44.9157 14.6512H41.9717L41.0619 11.8516Z",
    fill: "#FCD100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1688 20.7448L31.2545 23.5488H28.3105L30.6946 25.2811L29.7847 28.0763L32.1688 26.3484L34.5485 28.0763L33.6386 25.2811L36.0183 23.5488H33.0743L32.1688 20.7448Z",
    fill: "#FCD100"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0787 47.853L32.1688 45.0533L31.2545 47.853H28.3105L30.6946 49.5809L29.7847 52.3805L32.1688 50.6526L34.5485 52.3805L33.6386 49.5809L36.0183 47.853H33.0787Z",
    fill: "#FCD100"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9717 56.7507L41.0619 53.951L40.152 56.7507H37.208L39.5921 58.4786L38.6778 61.2782L41.0619 59.5459L43.4415 61.2782L42.5317 58.4786L44.9157 56.7507H41.9717Z",
    fill: "#FCD100"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3762 35.701H78.4322L77.5179 32.897L76.608 35.701H73.6641L76.0481 37.4289L75.1382 40.2286L77.5179 38.5007L79.8976 40.2286L78.9921 37.4289L81.3762 35.701Z",
    fill: "#FCD100"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3661 11.8516L64.4562 14.6512H61.5166L63.8963 16.3791L62.9864 19.1787L65.3661 17.4464L67.7458 19.1787L66.8403 16.3791L69.2199 14.6512H66.276L65.3661 11.8516Z",
    fill: "#FCD100"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7932 25.2811L71.8834 28.0763L74.263 26.3484L76.6427 28.0763L75.7372 25.2811L78.1169 23.5488H75.1729L74.263 20.7448L73.3532 23.5488H70.4092L72.7932 25.2811Z",
    fill: "#FCD100"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1729 47.853L74.263 45.0533L73.3532 47.853H70.4092L72.7932 49.5809L71.8834 52.3805L74.263 50.6526L76.6427 52.3805L75.7372 49.5809L78.1169 47.853H75.1729Z",
    fill: "#FCD100"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.276 56.7507L65.3661 53.951L64.4562 56.7507H61.5166L63.8963 58.4786L62.9864 61.2782L65.3661 59.5459L67.7458 61.2782L66.8403 58.4786L69.2199 56.7507H66.276Z",
    fill: "#FCD100"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEu);
export default __webpack_public_path__ + "static/media/EU.2560285a510367718dd6f2aff474ab3a.svg";
export { ForwardRef as ReactComponent };